import React, { useState } from 'react';
import { Ban, Loader2 } from 'lucide-react';
import { Button, Modal } from '../../shared/ui';
import { AVIS_HORS_SAV, horsSavPossible, LIBELLE_HORS_SAV, marquerHorsSav, TEXTE_CONFIRMATION_HORS_SAV } from './horsSav';

const TACTILE = 'max-lg:min-h-10';

/**
 * Bouton « Pas une demande SAV » de la fiche, avec sa fenêtre de
 * confirmation. Après la décision, `surDecision` reçoit les champs à
 * fusionner dans le dossier affiché (statut clos) et la phrase à afficher.
 * Rien si le dossier est déjà clos.
 */
export const BoutonHorsSav: React.FC<{
  dossier: { id: string; status?: string } | object;
  surDecision: (maj: Record<string, unknown>, avis: string) => void;
  className?: string;
}> = ({ dossier, surDecision, className = '' }) => {
  const [ouvert, setOuvert] = useState(false);
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);
  if (!horsSavPossible(dossier)) return null;
  const id = (dossier as { id: string }).id;

  const confirmer = async () => {
    if (enCours) return;
    setEnCours(true);
    setErreur(null);
    try {
      const maj = await marquerHorsSav(id);
      setOuvert(false);
      surDecision(maj, AVIS_HORS_SAV);
    } catch (e) {
      setErreur(e instanceof Error && e.message ? e.message : 'La décision n’a pas pu être enregistrée.');
    } finally {
      setEnCours(false);
    }
  };

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        title="Clore ce dossier sans rien envoyer au client : ce n’est pas une demande SAV"
        onClick={() => { setErreur(null); setOuvert(true); }}
        className={`text-graphite ${TACTILE} ${className}`}
      >
        <Ban className="w-4 h-4 mr-1" aria-hidden="true" />{LIBELLE_HORS_SAV}
      </Button>
      <Modal isOpen={ouvert} onClose={() => { if (!enCours) setOuvert(false); }} title={`${LIBELLE_HORS_SAV} ?`} size="sm">
        <div className="space-y-4">
          <p className="text-sm text-graphite">{TEXTE_CONFIRMATION_HORS_SAV}</p>
          {erreur && <p role="alert" className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-800">{erreur}</p>}
          <div className="flex flex-col gap-2 sm:flex-row sm:justify-end">
            <Button variant="secondary" disabled={enCours} onClick={() => setOuvert(false)} className={`w-full sm:w-auto ${TACTILE}`}>Annuler</Button>
            <Button variant="danger" disabled={enCours} onClick={() => void confirmer()} className={`w-full sm:w-auto ${TACTILE}`}>
              {enCours && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" aria-hidden="true" />}
              Clore sans rien envoyer
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default BoutonHorsSav;
